export default __webpack_public_path__ + "static/media/bingo_bg.785df68e.png";